import { Link } from "react-router-dom";
import { Layers, Play, ShieldCheck } from "lucide-react";
import { RunsList } from "@/components/organisms/reports/RunsList";

export function StudioDeploymentPage() {
  return (
    <div className="space-y-6">
      <section className="studio-hero">
        <div>
          <div className="studio-eyebrow">Deployment - evidence first</div>
          <h1 className="studio-title">
            Deployments <em>from checked runs.</em>
          </h1>
          <p className="studio-subtitle">
            Review implementation runs, release findings, generated artifacts, and approval-ready outputs before shipping.
          </p>
        </div>
        <div className="flex flex-wrap gap-2">
          <Link to="/salesforce-releases" className="studio-button">
            <ShieldCheck className="h-4 w-4" />
            Release scan
          </Link>
          <Link to="/migrations" className="studio-button studio-button-primary">
            <Play className="h-4 w-4" />
            Run migration
          </Link>
        </div>
      </section>

      <div className="grid gap-4 md:grid-cols-3">
        <Card icon={<Layers className="h-4 w-4" />} title="Plan" text="Pick a migration or agent run." />
        <Card icon={<ShieldCheck className="h-4 w-4" />} title="Validate" text="Review scans and artifacts." />
        <Card icon={<Play className="h-4 w-4" />} title="Execute" text="Keep the output auditable." />
      </div>

      <RunsList />
    </div>
  );
}

function Card({ icon, title, text }: { icon: React.ReactNode; title: string; text: string }) {
  return (
    <div className="studio-card p-4">
      <div className="mb-3 inline-flex h-9 w-9 items-center justify-center rounded-md bg-muted text-foreground">{icon}</div>
      <div className="font-semibold">{title}</div>
      <p className="mt-1 text-sm text-muted-foreground">{text}</p>
    </div>
  );
}
